import React, { useState, useEffect } from "react";
import { Typography, Box } from '@mui/material';
import MuiTextField from 'components/mui3-forms/MuiTextField';
import MuiSelectDropdown from 'components/mui3-forms/MuiSelectDropdown';
import { pesticideUnitOptions } from "utils/DynamicFields";
import MuiMultiSelect from 'components/mui-forms/MuiMultiSelect';
import MuiCollapseComponent from 'components/mui3-forms/MuiCollapseComponent';
import MuiNestedDropDown from "components/mui3-forms/MuiNestedDropdown";
import MuiNestedSubDropDown from "components/mui3-forms/MuiNestedSubDropdown";
import MuiTextFieldArea from 'components/mui3-forms/MuiTextFieldArea';
import _ from 'lodash';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerModal from 'mui-components/kart/fieldmap/tasktemplates/TimerModal';

const AddTaskTemplateNonWaterJournal = (props) => {
  const { intl, createdVehicleId, createdEquipmentId, fieldMasterData, activitiesCommon, onFieldChange, formData, handleNumericValidation, waterUnitOptions, getWindSpeedOptions, weatherOptions, vehicleOptions, equipmentOptions, formErrors, openTimerDialog, handleCancelTimerButton, handleOkTimerButton, handleHoursChange, handleMinutesChange, currentTimerHourValue, currentTimerMinutesValue, isTimerOpen, initialData } = props;
  let pesticideDropdowns = _.filter(activitiesCommon, ['activityId', 'act19'])[0].dropdowns[2].elements;
  let growthStageDropdowns = _.filter(activitiesCommon, ['activityId', 'act19'])[0].dropdowns[3].elements;
  const [selectedPesticideTypes, setSelectedPesticideTypes] = useState([]);

  useEffect(() => {
    if (formData.pesticideType?.length > 0) {
      setSelectedPesticideTypes(formData.pesticideType);
    }
  }, [formData.pesticideType]);

  useEffect(() => {
    if (formData.pesticideType?.length > 0) {
      const updatedFormData = { ...formData };
      formData.pesticideType.forEach((_, index) => {
        const amountKey = `pesticideType.${index}.amount`;
        const unitKey = `pesticideType.${index}.unit`;
        updatedFormData[amountKey] = formData[amountKey];
        updatedFormData[unitKey] = formData[unitKey];
      });
      setSelectedPesticideTypes(formData.pesticideType);
    }
  }, [formData.pesticideType]);

  let pestDataValue = {
    element: formData?.taskActivity?.pestData,
    leaves: formData?.taskActivity['pestSubList'] || null
  }

  let growthStageValue = {
    element: formData.taskActivity?.growthStage || null,
    subElement: formData.taskActivity?.growthStageSub || null,
    leaf: formData.taskActivity?.growthStageSubSubType || null
  }

  const handlePesticideTypeChange = (event) => {
    setSelectedPesticideTypes(event.target.value);
    if (onFieldChange) {
      onFieldChange('pesticideType', event.target.value);
    }
  };

  // Effect of pesticide application
  const getEffectOfApplicationValues = () => {
    const values = ['God', 'Ok', 'Dårlig'];
    return values.map(value => ({
      value,
      label: value,
    }));
  };

  // Crop List
  const getDropDownFieldsStatuses = dropdownList => {
    return dropdownList?.map(item => ({
      value: item.name,
      label: item.name
    }));
  };

  // Pesticide type options
  const pesticideTypeOptions = (activitiesCommon) => {
    const pesticideActivity = activitiesCommon?.find(
      (activity) => activity.activityId === 'act19'
    );
    const pesticideDropdown = pesticideActivity?.dropdowns?.find(
      (dropdown) => dropdown.element === 'pesticide'
    );
    return pesticideDropdown?.leaves || [];
  };

  return (
    <Box sx={{
      // padding: '0px 24px 0px 24px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#A8A8A8',
        borderRadius: '4px',
        transition: 'background-color 0.3s ease',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#B8B8B8',
      }
    }}
    >
      <Box sx={{ width: '100%', display: "flex", alignItems: "center", paddingTop: '56px' }}>
        {/* Crop */}
        <MuiSelectDropdown
          defaultLabel={`${intl.formatMessage({ id: 'CT_CR' })}*`}
          defaultValue={formData.taskActivity?.crop || initialData.taskActivity?.crop || ''}
          fieldName='crop'
          options={getDropDownFieldsStatuses(fieldMasterData.cropList)}
          autoFocus={false}
          required={true}
          onChange={onFieldChange}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: '250px', // Adjust this value (in pixels) to your desired height
              },
            },
          }}
          activityId="act19"
          showEmptySpace={false}
        />
      </Box>
      {/* Type of pest control agent - Error handling has to be done */}
      <Box sx={{ width: '100%', display: "flex", flexDirection: 'column', alignItems: "flex-start", paddingTop: '56px' }}>
        <MuiMultiSelect
          label={intl.formatMessage({ id: 'TYPE_OF_PESTICIDE' })}
          value={selectedPesticideTypes}
          name='pesticideType.name'
          options={pesticideTypeOptions(activitiesCommon)}
          onChange={handlePesticideTypeChange}
          autoFocus={false}
          fullWidth={true}
          required={true}
          errorHelperText={formErrors['pesticideType.name']}
          customSx={{
            width: '100%',
            marginLeft: 0,
            '& .MuiFormControl-root': {
              width: '100% !important',
              marginLeft: 0,
            },
            '& .MuiOutlinedInput-root': {
              width: '100% !important',
            },
            '& .MuiSelect-select': {
              width: '100% !important',
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: '250px', // Adjust this value (in pixels) to your desired height
              },
            },
          }}
        />

        {selectedPesticideTypes.map((pesticideName, index) => {
          const fieldKey = `pesticideType[${pesticideName || 'default'}]`;
          return (
            <Box
              key={fieldKey}
              sx={{ display: 'flex', flexDirection: 'column', gap: '16px', paddingTop: '24px', width: '100%' }}
            >
              <Typography variant="subtitle1">{pesticideName}</Typography>
              <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center', width: '100%' }}>
                {/* Pesticide Amount */}
                <MuiTextField
                  defaultLabel={intl.formatMessage({ id: 'AMOUNT_OF_PESTICIDE' })}
                  defaultValue={formData[`pesticideType.${index}.amount`] || ''}
                  numberKeypad={true}
                  fieldName={`pesticideType.${index}.amount`}
                  onChange={handleNumericValidation}
                  autoFocus={false}
                  required={true}
                  errorHelperText={formErrors[`pesticideType.${index}.amount`]}
                  fullWidth
                  activityId="act19"
                />
                {/* Pesticide Unit */}
                <MuiSelectDropdown
                  defaultLabel={`${intl.formatMessage({ id: 'CT_UNIT' })}*`}
                  defaultValue={formData[`pesticideType.${index}.unit`] || ''}
                  fieldName={`pesticideType.${index}.unit`}
                  options={pesticideUnitOptions()}
                  required={true}
                  autoFocus={false}
                  fullWidth
                  onChange={onFieldChange}
                  activityId="act19"
                />
              </Box>
            </Box>
          );
        })}

        {selectedPesticideTypes.length === 0 && (
          <Box sx={{ display: 'flex', gap: '16px', paddingTop: '24px', alignItems: 'center', width: '100%' }}>
            {/* Pesticide Amount - Shown when no pesticide types are selected */}
            <MuiTextField
              defaultLabel={intl.formatMessage({ id: 'AMOUNT_OF_PESTICIDE' })}
              defaultValue={formData.pesticideType?.default?.amount || ''}
              fieldName="pesticideType.0.amount"
              numberKeypad={true}
              onChange={handleNumericValidation}
              autoFocus={false}
              required={true}
              errorHelperText={formErrors['pesticideType.0.amount']}
              fullWidth
              activityId="act19"
            />
            {/* Pesticide Unit - Shown when no pesticide types are selected */}
            <MuiSelectDropdown
              defaultLabel={`${intl.formatMessage({ id: 'CT_UNIT' })}*`}
              defaultValue={formData.pesticideType?.default?.unit || ''}
              fieldName="pesticideType.0.unit"
              options={pesticideUnitOptions()}
              required={true}
              autoFocus={false}
              fullWidth
              onChange={onFieldChange}
              activityId="act19"
              showEmptySpace={true}
            />
          </Box>
        )}
      </Box>
      {/* Reason for pesticide application */}
      <Box sx={{ display: "flex", alignItems: "center", paddingTop: '32px' }}>
        <MuiTextField
          defaultLabel={intl.formatMessage({ id: 'RFPA' })}
          defaultValue={formData.taskActivity?.reason || ''}
          fieldName="reason"
          onChange={onFieldChange}
          required={true}
          errorHelperText={formErrors['reason']}
          activityId="act19"
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* Pest including subtypes - 2 level dropdown */}
        <MuiNestedDropDown
          label={`${intl.formatMessage({ id: 'PEST_SUBTYPE' })}*`}
          options={pesticideDropdowns}
          defaultValue={pestDataValue}
          onChange={(value) => onFieldChange('pestInfo', value)}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", marginTop: '24px' }}>
        {/* Effect of application */}
        <MuiSelectDropdown
          defaultLabel={`${intl.formatMessage({ id: 'EFFECT' })}*`}
          defaultValue={formData.taskActivity?.effectApplication || ''}
          fieldName='effectApplication'
          options={getEffectOfApplicationValues()}
          required={true}
          autoFocus={false}
          onChange={onFieldChange}
          activityId="act19"
          showEmptySpace={false}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
        <MuiTextFieldArea
          defaultLabel={intl.formatMessage({ id: 'NOTE' })}
          defaultValue={formData?.note || ''}
          fieldName='note'
          onChange={onFieldChange}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
        <MuiCollapseComponent
          title={intl.formatMessage({ id: 'TASK_MORE_INFORMATION_OPTIONAL' })}
          content={
            <Box sx={{ marginTop: '48px', width: '100%' }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <MuiTextField
                  defaultLabel={intl.formatMessage({ id: 'TIME_SPENT' })}
                  defaultValue={`${currentTimerHourValue} : ${currentTimerMinutesValue}`}
                  inputAdornment={<AccessTimeIcon />}
                  position="start"
                  fieldName='timeSpent'
                  autoFocus={false}
                  onClick={openTimerDialog}
                  readOnly={true}
                  activityId="act19"
                />
              </Box>
              {/* Water Volume amount and unit */}
              <Box sx={{ display: "flex", gap: '16px', alignItems: "center", paddingTop: '32px' }}>
                <MuiTextField
                  defaultLabel={intl.formatMessage({ id: 'CT_WATERAMOUNT' })}
                  defaultValue={formData.taskActivity?.waterAmount || ''}
                  numberKeypad={true}
                  fieldName='waterAmount'
                  onChange={handleNumericValidation}
                  autoFocus={false}
                  errorHelperText={formErrors['waterAmount']}
                  activityId="act19"
                />
                <MuiSelectDropdown
                  defaultLabel={intl.formatMessage({ id: 'WATER_VOLUME_UNIT' })}
                  defaultValue={formData.taskActivity?.waterUnit || ''}
                  options={waterUnitOptions()}
                  fieldName='waterUnit'
                  autoFocus={false}
                  onChange={onFieldChange}
                  activityId="act19"
                />
              </Box>
              {/* growth stage - three level dropdown */}
              <Box sx={{ display: "flex", alignItems: "center", marginTop: '32px' }}>
                <MuiNestedSubDropDown
                  label={intl.formatMessage({ id: 'DEVELOPMENT_STAGE_ST' })}
                  options={growthStageDropdowns}
                  defaultValue={growthStageValue}
                  onChange={(value) => onFieldChange('growthStageNested', value)}
                />
              </Box>
              {/* Weather and Wind */}
              <Box sx={{ display: "flex", gap: '24px', paddingTop: '56px', alignItems: "center" }}>
                <MuiSelectDropdown
                  defaultLabel={intl.formatMessage({ id: 'WEATHER' })}
                  defaultValue={formData.weather}
                  options={weatherOptions}
                  fieldName='weather'
                  autoFocus={false}
                  onChange={onFieldChange}
                  activityId="act19"
                  showEmptySpace={false}
                />
                <MuiSelectDropdown
                  defaultLabel={intl.formatMessage({ id: 'WIND' })}
                  defaultValue={formData.taskActivity?.windSpeed || ''}
                  inputAdornment={intl.formatMessage({ id: 'WIND_UNIT' })}
                  fieldName="windSpeed"
                  options={getWindSpeedOptions()}
                  autoFocus={false}
                  onChange={onFieldChange}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: '250px', // Adjust this value (in pixels) to your desired height
                      },
                    },
                  }}
                  activityId="act19"
                  showEmptySpace={false}
                />
              </Box>
              {/* Vehicle */}
              <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
                <MuiSelectDropdown
                  key={createdVehicleId}
                  defaultLabel={intl.formatMessage({ id: 'VEHICLE' })}
                  defaultValue={formData.vehicleAssetId}
                  options={vehicleOptions()}
                  fieldName="vehicleAssetId"
                  onChange={onFieldChange}
                  activityId="act19"
                  showEmptySpace={false}
                />
              </Box>
              {/* Equipment */}
              <Box sx={{ display: "flex", alignItems: "center", paddingTop: '24px' }}>
                <MuiSelectDropdown
                  key={createdEquipmentId}
                  defaultLabel={intl.formatMessage({ id: 'EQUIPMENT' })}
                  defaultValue={formData.equipmentAssetId}
                  options={equipmentOptions()}
                  fieldName="equipmentAssetId"
                  onChange={onFieldChange}
                  showEmptySpace={false}
                />
              </Box>
              {/* Performed By */}
              <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
                <MuiTextField
                  defaultLabel={intl.formatMessage({ id: 'PERFORMED_BY' })}
                  defaultValue={formData.taskActivity?.performedBy || ''}
                  fieldName="performedBy"
                  onChange={onFieldChange}
                />
              </Box>
            </Box>
          }
        />
      </Box>
      <Box>
        <TimerModal
          intl={intl}
          isTimerOpen={isTimerOpen}
          handleCancelTimerButton={handleCancelTimerButton}
          handleOkTimerButton={handleOkTimerButton}
          handleHoursChange={handleHoursChange}
          handleMinutesChange={handleMinutesChange}
          formErrors={formErrors}
          formState={formData}
        />
      </Box>
    </Box >
  );
};

export default AddTaskTemplateNonWaterJournal;